module.exports = __webpack_public_path__ + "img/img_21.c4e5ffbc.png";